<template>
    <div>
        <div
            class="product__img-on-focus-container"
            id="product__img-on-focus-container"
        >
            <img
                :src="imageOnFocus.large_url"
                v-show="!videoLoaded"
                alt=""
                class="product__img-on-focus"
            />

            <div
                v-if="videoLoaded"
                class="embed-responsive embed-responsive-4by3"
            >
                <iframe
                    class="embed-responsive-item"
                    :src="video"
                    allowfullscreen
                ></iframe>
            </div>
        </div>

        <img
            v-for="(image, index) in itemImages"
            :src="image.small_url"
            @click="updateImageOnFocus(image)"
            alt=""
            :class="getClassName(index)"
        />

        <a
            href="#"
            v-if="video"
            @click.prevent="loadVideo"
            class="product__btn-video-play"
        >
        </a>

        <div v-show="isZoomEnabled" class="product__img-zoom-container"></div>
    </div>
</template>

<script>
import "jquery-zoom";

export default {
    name: "Images",

    props: ["images", "video"],

    mounted() {
        this.$nextTick(function() {
            if (this.itemImages.length) {
                this.updateImageOnFocus(this.itemImages[0]);
            }
        });
    },

    data() {
        return {
            imageOnFocus: {},
            itemImages: JSON.parse(this.images),
            isZoomEnabled: false,
            videoLoaded: false
        };
    },

    methods: {
        updateImageOnFocus(image) {
            this.videoLoaded = false;
            this.imageOnFocus = image;

            $("#product__img-on-focus-container").zoom({
                url: this.imageOnFocus.original_url,
                target: ".product__img-zoom-container",
                onZoomIn: this.zoomIn,
                onZoomOut: this.zoomOut
            });
        },

        zoomIn() {
            this.isZoomEnabled = true;
        },

        zoomOut() {
            this.isZoomEnabled = false;
        },

        getClassName(index) {
            let name = "zoom-image-" + index;
            let classObj = {};
            classObj[name] = true;
            classObj["product__img-zoom-thumb"] = true;
            return classObj;
        },

        loadVideo() {
            this.videoLoaded = true;
            $("#product__img-on-focus-container").trigger("zoom.destroy");
        }
    }
};
</script>
